/* CLUTCH 2026 - product card actions (add to cart + wishlist), wishlist page, sort in filter drawer */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'clutch:wishlist';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.5 15.4 3.5 9.3A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 8.5 1.7c0 6.1-8.5 11.2-8.5 11.2z"/></svg>';
  var cache = {};

  /* ---------- wishlist store (saved in this browser) ---------- */
  function readList() {
    try {
      var l = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(l) ? l : [];
    } catch (e) { return []; }
  }

  function writeList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    syncHearts();
    updateCount();
  }

  function toggleWish(handle) {
    var list = readList();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.unshift(handle); }
    writeList(list);
    if (document.querySelector('[data-clutch-wishlist]')) { renderWishlist(); }
  }

  function syncHearts() {
    var list = readList();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wish) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function updateCount() {
    var n = readList().length;
    document.querySelectorAll('.clutch-wl-count').forEach(function (c) {
      c.textContent = n;
      c.hidden = n === 0;
    });
  }

  /* ---------- helpers ---------- */
  function money(cents) {
    try {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function handleFromHref(href) {
    var i = (href || '').indexOf('/products/');
    if (i < 0) { return null; }
    var h = href.slice(i + 10).split('?')[0].split('#')[0].split('/')[0];
    try { h = decodeURIComponent(h); } catch (e) {}
    return h || null;
  }

  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) { throw new Error('not found'); } return r.json(); });
    }
    return cache[handle];
  }

  function heartButton(handle, extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'clutch-wish' + (extraClass ? ' ' + extraClass : '');
    b.dataset.wish = handle;
    b.setAttribute('aria-label', 'Add to wishlist');
    b.innerHTML = HEART;
    return b;
  }

  /* Shows HELEN MAXI DRESS on one line and the colour (after the dash) below it */
  function splitTitle(node) {
    if (!node || node.dataset.clutchSplit) { return; }
    node.dataset.clutchSplit = '1';
    var text = (node.textContent || '').trim();
    var i = text.lastIndexOf(' - ');
    var name = document.createElement('span');
    name.className = 'clutch-name';
    name.textContent = i > 0 ? text.slice(0, i) : text;
    node.textContent = '';
    node.appendChild(name);
    if (i > 0) {
      var sub = document.createElement('span');
      sub.className = 'clutch-subname';
      sub.textContent = text.slice(i + 3);
      node.appendChild(sub);
    }
  }

  /* ---------- product cards ---------- */
  function decorate() {
    document.querySelectorAll('.grid-product[data-product-handle], [data-clutch-product]').forEach(function (el) {
      if (el.dataset.clutchDone) { return; }
      el.dataset.clutchDone = '1';
      var handle = el.dataset.productHandle;
      if (!handle) { return; }
      splitTitle(el.querySelector('.grid-product__title'));

      var actions = document.createElement('div');
      actions.className = 'clutch-actions';
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'clutch-actions__add';
      add.textContent = 'Add to cart';
      actions.appendChild(add);
      actions.appendChild(heartButton(handle));

      var sizes = document.createElement('div');
      sizes.className = 'clutch-sizes';
      sizes.hidden = true;

      el.appendChild(actions);
      el.appendChild(sizes);
    });

    document.querySelectorAll('a.clutch-card').forEach(function (card) {
      if (card.dataset.clutchDone) { return; }
      card.dataset.clutchDone = '1';
      var handle = handleFromHref(card.getAttribute('href'));
      var media = card.querySelector('.clutch-card__media');
      if (handle && media) { media.appendChild(heartButton(handle, 'clutch-wish--float')); }
      splitTitle(card.querySelector('.clutch-card__title'));
    });

    syncHearts();
  }

  function addVariant(id, btn) {
    if (btn) { btn.disabled = true; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (btn) { btn.disabled = false; }
      if (!r.ok) { if (btn) { btn.textContent = 'Unavailable'; btn.disabled = true; } return; }
      /* The theme listens for this event: it rebuilds and opens the cart drawer */
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} }));
    }).catch(function () { if (btn) { btn.disabled = false; } });
  }

  function onAdd(btn) {
    var wrap = btn.closest('[data-product-handle]');
    if (!wrap) { return; }
    var panel = wrap.querySelector('.clutch-sizes');
    if (panel && panel.children.length) { panel.hidden = !panel.hidden; return; }

    btn.disabled = true;
    getProduct(wrap.dataset.productHandle).then(function (p) {
      btn.disabled = false;
      if (!p.available) { btn.textContent = 'Sold out'; btn.disabled = true; return; }
      if (p.variants.length === 1) { addVariant(p.variants[0].id, btn); return; }

      var label = document.createElement('span');
      label.className = 'clutch-sizes__label';
      label.textContent = 'Select ' + ((p.options && p.options[0] && p.options[0].name) || 'option').toLowerCase();
      panel.appendChild(label);
      p.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.variant = v.id;
        b.textContent = v.public_title || v.title;
        b.disabled = !v.available;
        panel.appendChild(b);
      });
      panel.hidden = false;
    }).catch(function () { btn.disabled = false; });
  }

  /* ---------- wishlist page ---------- */
  function renderWishlist() {
    var grid = document.querySelector('[data-clutch-wishlist]');
    if (!grid) { return; }
    var empty = document.querySelector('[data-clutch-wishlist-empty]');
    var list = readList();
    if (!list.length) {
      grid.textContent = '';
      if (empty) { empty.hidden = false; }
      return;
    }
    if (empty) { empty.hidden = true; }

    Promise.all(list.map(function (h) {
      return getProduct(h).catch(function () { return null; });
    })).then(function (products) {
      grid.textContent = '';
      products.forEach(function (p) {
        if (!p) { return; }
        var item = document.createElement('div');
        item.className = 'clutch-wl__item';
        item.dataset.clutchProduct = '1';
        item.dataset.productHandle = p.handle;

        var link = document.createElement('a');
        link.className = 'clutch-wl__img';
        link.href = root + 'products/' + p.handle;
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600';
          img.alt = p.title;
          img.loading = 'lazy';
          link.appendChild(img);
        }
        item.appendChild(link);

        var title = document.createElement('a');
        title.className = 'clutch-wl__title grid-product__title';
        title.href = link.href;
        title.textContent = p.title;
        item.appendChild(title);

        var price = document.createElement('div');
        price.className = 'clutch-wl__price';
        price.innerHTML = money(p.price);
        item.appendChild(price);

        grid.appendChild(item);
      });
      decorate();
    });
  }

  /* ---------- header link and product page button ---------- */
  function initHeader() {
    var icons = document.querySelector('.site-nav__icons');
    if (!icons || icons.querySelector('.clutch-wl-link')) { return; }
    var a = document.createElement('a');
    a.href = root + 'pages/wishlist';
    a.className = 'site-nav__link site-nav__link--icon clutch-wl-link';
    a.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-clutch-heart" viewBox="0 0 64 64"><path d="M32 54S8 40 8 24a12 12 0 0 1 24-4 12 12 0 0 1 24 4c0 16-24 30-24 30z"/></svg>' +
      '<span class="icon__fallback-text">Wishlist</span><span class="clutch-wl-count" hidden></span>';
    var cart = icons.querySelector('.js-drawer-open-cart');
    if (cart) { icons.insertBefore(a, cart); } else { icons.appendChild(a); }
  }

  function initProductPage() {
    if (window.location.pathname.indexOf('/products/') < 0) { return; }
    var handle = handleFromHref(window.location.pathname);
    var form = document.querySelector('.product-single__form');
    if (!handle || !form || document.querySelector('.clutch-pdp-wish')) { return; }
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'clutch-pdp-wish';
    b.dataset.wish = handle;
    b.innerHTML = HEART + '<span>Wishlist</span>';
    form.parentNode.insertBefore(b, form.nextSibling);
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var wish = e.target.closest('[data-wish]');
    if (wish) {
      e.preventDefault();
      e.stopPropagation();
      toggleWish(wish.dataset.wish);
      return;
    }
    var add = e.target.closest('.clutch-actions__add');
    if (add) { e.preventDefault(); onAdd(add); return; }
    var size = e.target.closest('.clutch-sizes button[data-variant]');
    if (size) {
      e.preventDefault();
      var panel = size.closest('.clutch-sizes');
      addVariant(parseInt(size.dataset.variant, 10), size).then(function () { if (panel) { panel.hidden = true; } });
    }
  }, true);

  /* Sort By inside the filter drawer drives the theme's own sort select */
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.matches || !r.matches('[data-clutch-sort]')) { return; }
    var select = document.getElementById('SortBy');
    if (!select) { return; }
    select.value = r.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function init() {
    initHeader();
    initProductPage();
    decorate();
    renderWishlist();
    updateCount();

    /* Collections reload their grid without a page load, so watch for new cards */
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { initHeader(); decorate(); updateCount(); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
